import type { ProductId } from '.';
import * as Iap from '.';
import type { GemsProductId, ProductReward } from './iap.ruleset';
import type { State } from '../State';
import { assertNever } from '../utils';

export const isProductId = (productId: string): productId is ProductId =>
  Iap.ruleset.productIds.includes(productId as ProductId);

export const isProductIdGems = (
  productId: ProductId,
): productId is GemsProductId => Iap.ruleset.gemsProductIds.includes(productId);

export const getProductRewards = (
  productId: ProductId,
  _state?: State,
  _now?: number,
): ProductReward => {
  if (isProductIdGems(productId)) {
    return Iap.ruleset.gemsRewardTable[productId];
  }

  assertNever(productId);
};

/**
 * Return Stripe price ID by product ID
 */
export function getStripePriceIdByProductId(productId: ProductId) {
  const { productIds, stripeLivePriceIds, stripeTestPriceIds } = Iap.ruleset;
  if (!productIds.includes(productId)) {
    throw new Error('Unknown product: ' + productId);
  }

  const priceId = process.env.IS_DEVELOPMENT
    ? stripeTestPriceIds[productId]
    : stripeLivePriceIds[productId];

  return priceId;
}
